import { render, staticRenderFns } from "./ToggleOptions.vue?vue&type=template&id=bb596c52&scoped=true&"
import script from "./ToggleOptions.vue?vue&type=script&lang=js&"
export * from "./ToggleOptions.vue?vue&type=script&lang=js&"
import style0 from "./ToggleOptions.vue?vue&type=style&index=0&id=bb596c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb596c52",
  null
  
)

export default component.exports